import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { type SessionFile } from "@/shared/domain/sessions/SessionFile";
import { type PaginatedResponse } from "@/shared/http";

import { sessionQueryKeys } from "./sessionQueryKeys";

export interface UseSessionFilesParams {
  sessionId: string;
  pageToken?: string;
  /** Server page size; the backend defaults to 100 when omitted. */
  limit?: number;
}

/**
 * Fetches one page of file contributions for a Session.
 */
export function useSessionFiles({
  sessionId,
  pageToken,
  limit,
}: UseSessionFilesParams): UseQueryResult<
  PaginatedResponse<SessionFile>,
  Error
> {
  const { sessionService } = useDomainServices();
  return useQuery<PaginatedResponse<SessionFile>, Error>({
    queryKey: sessionQueryKeys.files(sessionId, pageToken, limit),
    queryFn: ({ signal }) =>
      sessionService.listSessionFiles(sessionId, {
        abortSignal: signal,
        limit,
        pageToken,
      }),
  });
}
